export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: 'kr' | 'jp' | 'cn';
  categoryLabel: string;
  cover: string;
  description: string;
  status: 'ongoing' | 'completed';
  statusLabel: string;
  rating: number;
  views: number;
  tags: string[];
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
}

export const categories = [
  { slug: 'kr', label: '韩漫', icon: 'ri-book-open-line' },
  { slug: 'jp', label: '日漫', icon: 'ri-book-read-line' },
  { slug: 'cn', label: '国漫', icon: 'ri-book-marked-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-01',
    title: '独步天下',
    author: '李贤秀',
    category: 'kr',
    categoryLabel: '韩漫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20comic%20cover%20art%2C%20martial%20arts%20theme%2C%20dynamic%20action%20pose%20with%20traditional%20Korean%20warrior%20in%20flowing%20robes%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20ink%20wash%20painting%20style%20background%2C%20clean%20composition%2C%20modern%20webtoon%20aesthetic%2C%20soft%20gradient%20overlay%2C%20professional%20illustration%20quality&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '天下大势，分久必合。少年叶凡身怀绝世武脉，却因家族被灭而流落街头。在一次意外中，他获得了一本神秘的武学秘籍，从此踏上了一条逆天改命的修炼之路。在这条充满荆棘的道路上，他将遇到无数的挑战与机遇，结识志同道合的伙伴，也会面对强大的敌人。究竟他能否在这乱世之中成就一番霸业？',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.8,
    views: 1250000,
    tags: ['热血', '武侠', '玄幻', '战斗'],
    chapters: Array.from({ length: 186 }, (_, i) => ({
      id: `ch-kr-01-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 1 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-03',
    createdAt: '2024-03-15',
  },
  {
    id: 'comic-02',
    title: '重生之都市仙尊',
    author: '金泰亨',
    category: 'kr',
    categoryLabel: '韩漫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20modern%20webtoon%20cover%2C%20urban%20fantasy%20theme%2C%20handsome%20male%20protagonist%20in%20modern%20city%20background%2C%20mystical%20energy%20surrounding%20him%2C%20neon%20lights%20and%20traditional%20elements%20blend%2C%20dramatic%20composition%2C%20clean%20digital%20art%20style%2C%20professional%20manhwa%20illustration&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '一代仙尊重生回到高中时代，带着前世的记忆和修仙功法，他要在都市中重新崛起。面对曾经的敌人，他不会再犯同样的错误；面对昔日的遗憾，他要一一弥补。且看仙尊如何在现代都市中搅动风云，书写属于自己的传奇！',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.6,
    views: 980000,
    tags: ['重生', '都市', '修仙', '逆袭'],
    chapters: Array.from({ length: 152 }, (_, i) => ({
      id: `ch-kr-02-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 2 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-02',
    createdAt: '2024-06-20',
  },
  {
    id: 'comic-03',
    title: '甜蜜的陷阱',
    author: '朴美妍',
    category: 'kr',
    categoryLabel: '韩漫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20sweet%20romantic%20scene%20with%20couple%20in%20cherry%20blossom%20setting%2C%20soft%20pastel%20pink%20and%20warm%20tones%2C%20gentle%20lighting%2C%20dreamy%20atmosphere%2C%20modern%20webtoon%20style%2C%20clean%20illustration%2C%20emotional%20expression&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '28岁的职场女性林小晚，在一次公司聚会上遇到了年轻帅气的实习生。本以为只是一场普通的邂逅，却没想到这竟是一个精心设计的"陷阱"。他接近她的目的究竟是什么？当真相一点点揭开，她才发现，这场爱情游戏的背后，隐藏着一个令人震惊的秘密。',
    status: 'completed',
    statusLabel: '已完结',
    rating: 4.5,
    views: 1560000,
    tags: ['爱情', '都市', '悬疑', '职场'],
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-kr-03-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2025, 11, 1 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2025-12-01',
    createdAt: '2024-01-10',
  },
  {
    id: 'comic-04',
    title: '暗夜王者',
    author: '崔正宇',
    category: 'kr',
    categoryLabel: '韩漫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%2C%20mysterious%20antihero%20in%20black%20cloak%20with%20shadow%20powers%2C%20gothic%20cityscape%20at%20night%2C%20moonlight%20and%20deep%20shadows%2C%20dramatic%20contrast%20lighting%2C%20dark%20purple%20and%20silver%20accents%2C%20professional%20digital%20illustration&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '在永夜的都市中，有一个被称为"暗夜王者"的存在。他白天是普通的大学生，夜晚则化身为守护城市的神秘英雄。但当他发现城市背后的黑暗势力远超想象时，他必须做出选择：是继续隐藏身份，还是站出来与黑暗势力正面交锋？',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.7,
    views: 890000,
    tags: ['奇幻', '都市', '热血', '悬疑'],
    chapters: Array.from({ length: 134 }, (_, i) => ({
      id: `ch-kr-04-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 3 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-07-30',
    createdAt: '2024-08-05',
  },
  {
    id: 'comic-05',
    title: '进击的巨人：最终季',
    author: '山田一郎',
    category: 'jp',
    categoryLabel: '日漫',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%2C%20epic%20fantasy%20battle%20scene%2C%20warriors%20with%20swords%20facing%20giant%20monsters%2C%20dramatic%20action%20composition%2C%20dynamic%20movement%20lines%2C%20intense%20expression%2C%20dark%20atmosphere%2C%20professional%20shonen%20manga%20illustration%20quality&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '人类与巨人的战争进入最终阶段。艾伦率领调查兵团向马莱发起了最后的进攻。在这场决定人类命运的终极之战中，昔日的伙伴变成了敌人，曾经的信念受到了前所未有的考验。自由的代价究竟是什么？一切的答案都将在最终季中揭晓。',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.9,
    views: 2300000,
    tags: ['热血', '奇幻', '战斗', '末世'],
    chapters: Array.from({ length: 210 }, (_, i) => ({
      id: `ch-jp-01-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 0 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-04',
    createdAt: '2023-05-01',
  },
  {
    id: 'comic-06',
    title: '咒术师物语',
    author: '佐藤健太',
    category: 'jp',
    categoryLabel: '日漫',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20supernatural%20manga%20cover%2C%20young%20sorcerer%20casting%20spells%20with%20glowing%20runes%2C%20mystical%20Japanese%20temple%20background%2C%20flowing%20energy%20effects%2C%20traditional%20and%20modern%20fusion%20style%2C%20dynamic%20composition%2C%20professional%20manga%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '在一个被咒灵威胁的现代世界中，咒术师们是守护人类的最后一道防线。高中生虎杖悠仁在一次意外中吞下了诅咒之王的手指，从此获得了强大的咒力。为了拯救更多的人，他决定加入东京咒术高专，与同伴们一起对抗邪恶的咒灵。',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.8,
    views: 1800000,
    tags: ['奇幻', '热血', '校园', '战斗'],
    chapters: Array.from({ length: 178 }, (_, i) => ({
      id: `ch-jp-02-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 1 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-03',
    createdAt: '2024-02-14',
  },
  {
    id: 'comic-07',
    title: '樱花下的约定',
    author: '小林优子',
    category: 'jp',
    categoryLabel: '日漫',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20shojo%20manga%20cover%2C%20romantic%20high%20school%20love%20story%2C%20couple%20under%20blooming%20cherry%20blossom%20tree%2C%20soft%20spring%20colors%2C%20gentle%20watercolor%20style%2C%20dreamy%20atmosphere%2C%20emotional%20portrait%2C%20clean%20manga%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '春天，樱花盛开的季节。转学生小樱在樱花树下遇到了一个神秘的男孩，两人许下了"明年樱花再开时，我们再在这里相见"的约定。然而，当第二年樱花再次绽放时，男孩却消失得无影无踪。小樱决定踏上寻找他的旅程，却发现了一个跨越时空的感人秘密。',
    status: 'completed',
    statusLabel: '已完结',
    rating: 4.4,
    views: 670000,
    tags: ['爱情', '校园', '治愈', '青春'],
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-jp-03-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2025, 9, 1 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2025-10-01',
    createdAt: '2024-04-01',
  },
  {
    id: 'comic-08',
    title: '异世界美食家',
    author: '田中实',
    category: 'jp',
    categoryLabel: '日漫',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20isekai%20fantasy%20manga%20cover%2C%20cheerful%20cook%20in%20medieval%20fantasy%20world%2C%20delicious%20food%20floating%20around%2C%20magical%20ingredients%2C%20warm%20colorful%20illustration%2C%20adventure%20cooking%20theme%2C%20light%20hearted%20manga%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '一个普通的日本上班族意外穿越到了异世界。在这个剑与魔法的世界里，他唯一的金手指就是——精湛的厨艺！用现代的料理技巧征服异世界的味蕾，用美食结交各路强者。这不仅仅是一个关于美食的故事，更是一个关于友情与冒险的暖心之旅。',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.3,
    views: 540000,
    tags: ['异世界', '美食', '冒险', '喜剧'],
    chapters: Array.from({ length: 89 }, (_, i) => ({
      id: `ch-jp-04-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 2 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-02',
    createdAt: '2025-01-20',
  },
  {
    id: 'comic-09',
    title: '斗罗大陆V',
    author: '唐家三少',
    category: 'cn',
    categoryLabel: '国漫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20style%20comic%20cover%2C%20epic%20cultivation%20fantasy%2C%20young%20warrior%20with%20glowing%20martial%20spirit%2C%20ancient%20Chinese%20palace%20in%20background%2C%20mystical%20energy%20effects%2C%20traditional%20Chinese%20art%20elements%2C%20dramatic%20composition%2C%20professional%20illustration&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学而为唐门所不容。跳崖明志后，却意外穿越到了另一个世界——斗罗大陆。在这里，没有魔法，没有斗气，没有武术，只有神奇的武魂。且看唐三如何在这片神奇的大陆上，凭借自己的努力和智慧，一步步走向巅峰！',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.9,
    views: 3200000,
    tags: ['玄幻', '热血', '穿越', '战斗'],
    chapters: Array.from({ length: 256 }, (_, i) => ({
      id: `ch-cn-01-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 0 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-04',
    createdAt: '2023-01-01',
  },
  {
    id: 'comic-10',
    title: '沧海横流',
    author: '天蚕土豆',
    category: 'cn',
    categoryLabel: '国漫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%20art%2C%20cultivator%20flying%20above%20clouds%20with%20sword%2C%20ancient%20Chinese%20landscape%20mountains%20and%20rivers%2C%20ink%20wash%20painting%20style%2C%20ethereal%20atmosphere%2C%20golden%20light%20effects%2C%20traditional%20Chinese%20aesthetic%2C%20professional%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '沧海桑田，万物更迭。少年林动出身平凡，却怀揣着逆天改命的决心。在一场机缘巧合下，他获得了一枚神秘的祖符，从此踏上了修炼之路。从一个小小的家族子弟，到震动天地的绝世强者，他用实力证明：命运，从来都掌握在自己手中。',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.7,
    views: 2100000,
    tags: ['玄幻', '修仙', '热血', '成长'],
    chapters: Array.from({ length: 198 }, (_, i) => ({
      id: `ch-cn-02-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 1 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-03',
    createdAt: '2023-08-15',
  },
  {
    id: 'comic-11',
    title: '狐妖小红娘',
    author: '小新',
    category: 'cn',
    categoryLabel: '国漫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20fantasy%20manhua%20cover%2C%20beautiful%20fox%20spirit%20girl%20with%20traditional%20Chinese%20red%20dress%2C%20ancient%20Chinese%20garden%20setting%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20romantic%20atmosphere%2C%20delicate%20illustration%20style%2C%20professional%20manhua%20art&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '在人妖共存的世界里，有一群特殊的"红娘"——她们是狐妖一族，专门为前世有缘无分的人们牵线搭桥，让他们在今生再续前缘。涂山苏苏是狐妖一族最年轻的红娘，虽然法力低微，但她有着一颗赤诚的心。且看她如何用自己的方式，帮助一对对有情人了却前世的遗憾。',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.6,
    views: 1450000,
    tags: ['爱情', '奇幻', '古风', '喜剧'],
    chapters: Array.from({ length: 165 }, (_, i) => ({
      id: `ch-cn-03-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 2 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-02',
    createdAt: '2024-05-10',
  },
  {
    id: 'comic-12',
    title: '末日求生指南',
    author: '黑色火种',
    category: 'cn',
    categoryLabel: '国漫',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20post%20apocalyptic%20manhua%20cover%2C%20survivors%20in%20ruined%20city%20with%20weapons%2C%20dark%20dramatic%20atmosphere%2C%20zombie%20apocalypse%20theme%2C%20survival%20horror%20style%2C%20intense%20composition%2C%20modern%20Chinese%20comic%20illustration&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '一场突如其来的病毒席卷全球，被感染的人类变成了嗜血的怪物。普通的上班族陈默在末日中醒来，发现自己所在的城市已经变成了人间炼狱。为了活下去，他必须克服恐惧，团结幸存者，在这片废墟之上建立新的家园。但这仅仅是开始，更大的危机正在悄然逼近……',
    status: 'ongoing',
    statusLabel: '连载中',
    rating: 4.5,
    views: 1100000,
    tags: ['末世', '生存', '悬疑', '热血'],
    chapters: Array.from({ length: 142 }, (_, i) => ({
      id: `ch-cn-04-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updatedAt: new Date(2026, 7, 0 - i).toISOString().split('T')[0],
    })),
    updatedAt: '2026-08-04',
    createdAt: '2024-09-01',
  },
];

export const faqItems = [
  {
    question: '漫蛙漫画网上的漫画都是免费的吗？',
    answer: '是的！漫蛙漫画网上的所有漫画资源均为免费阅读，我们致力于为广大漫画爱好者提供优质的免费阅读体验。您可以随时随地在线浏览海量韩漫、日漫和国漫资源，无需支付任何费用。',
  },
  {
    question: '需要注册账号才能阅读漫画吗？',
    answer: '不需要。漫蛙漫画网支持游客模式直接阅读，您无需注册即可浏览所有漫画内容。当然，注册账号后可以享受更多便捷功能，如收藏漫画、阅读记录同步等。',
  },
  {
    question: '支持在手机上阅读漫画吗？',
    answer: '完全支持！漫蛙漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅的高清阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们与各大漫画平台保持密切合作，确保漫画更新及时。热门连载作品通常在原版发布后24小时内完成同步更新，让您不错过任何精彩内容。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航（韩漫、日漫、国漫）快速筛选感兴趣的漫画类型。也可以使用搜索功能，输入漫画名称或作者名进行精准查找。',
  },
  {
    question: '遇到阅读问题怎么办？',
    answer: '如果您在使用过程中遇到任何问题，可以通过"关于我们"页面的联系方式与我们取得联系。我们的客服团队会尽快为您解决。',
  },
];

export const testimonials = [
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '漫蛙漫画网真的太棒了！更新速度很快，画质也特别清晰。每天下班回家最期待的就是打开漫蛙看最新更新的漫画，已经成为我生活中不可或缺的一部分。',
    rating: 5,
  },
  {
    name: '追漫达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20warm%20smile%2C%20modern%20casual%20look%2C%20clean%20background%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '在这里找到了好多好看的韩漫！之前在其他平台找了好久都没找到的冷门作品，漫蛙上面居然都有。而且全部免费，真的是良心网站！',
    rating: 5,
  },
  {
    name: '二次元老宅',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20adult%20portrait%2C%20stylish%20glasses%2C%20friendly%20expression%2C%20casual%20outfit%2C%20clean%20studio%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '作为一个看了十几年漫画的老读者，漫蛙的资源量真的让我惊喜。日漫、国漫、韩漫应有尽有，分类清晰，阅读体验流畅。强烈推荐给所有喜欢看漫画的朋友！',
    rating: 5,
  },
];